import { StatusAuditDocument } from "../../../../enum/statusAuditDocument";
import { useDispatch } from "react-redux";
import { updateStatusAuditDoc, } from "../../../../store/generateQuote/actions";
var useAuditPage = function (setFileName, setPdfFile, setUploadTrigger, idQuote, idDocument, setOpenDrawerRejed) {
    var dispatch = useDispatch();
    var getCombustionLabel = function (combustionType) {
        switch (combustionType) {
            case "ELECTRIC":
                return "Eléctrico";
            case "GASOLINE":
                return "Gasolina";
            case "DIESEL":
                return "Diésel";
            case "GAS":
                return "Gas";
            default:
                return combustionType;
        }
    };
    var getStateFromStatus = function (status) {
        switch (status) {
            case "PENDING":
                return "Pendiente";
            case "REJECTED":
                return "Rechazado";
            default:
                return "Aprobado";
        }
    };
    var areRowsEqual = function (rows1, rows2) {
        return JSON.stringify(rows1) === JSON.stringify(rows2);
    };
    var quoteUploadAttachments = function (file) {
        if (file) {
            setFileName(file[0].name.replace(".pdf", ""));
            setPdfFile(file[0]);
            setUploadTrigger(true);
        }
    };
    var updateStatusAuditDocument = function (status, comment) {
        var body = {
            comment: comment,
        };
        dispatch(updateStatusAuditDoc({
            quoteId: idQuote,
            documentId: idDocument,
            status: status,
            body: body,
        }));
    };
    var applyValue = function (data) {
        updateStatusAuditDocument(StatusAuditDocument.REJECTED, data.descriptionValue.value);
        setOpenDrawerRejed(false);
    };
    return {
        getCombustionLabel: getCombustionLabel,
        getStateFromStatus: getStateFromStatus,
        areRowsEqual: areRowsEqual,
        quoteUploadAttachments: quoteUploadAttachments,
        updateStatusAuditDocument: updateStatusAuditDocument,
        applyValue: applyValue,
    };
};
export default useAuditPage;
